import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';

import { applyCoupon, removeCoupon } from '../BillingActions';
import Confirm from '../../../components/Confirm/Confirm';

// Import Style
import deleteIcon from '../../../assets/img/delete.svg';
import '../Billing.scss';

// Import Style

class Coupons extends Component {
  constructor(props) {
    super(props);

    this.state = {
      coupon: '',
      applied: false,
    };

    this.applyCoupon = this.applyCoupon.bind(this);
    this.removeCoupon = this.removeCoupon.bind(this);
  }

  componentDidMount() {
    if (this.props.data) {
      this.setState({ applied: !!this.props.data.coupon });
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.data, prevProps.data)) {
      this.setState({ applied: !!this.props.data.coupon });
    }
  }

  applyCoupon() {
    if (!this.state.coupon) {
      return false;
    }

    this.props.applyCoupon(this.state.coupon).then(() => {
      this.setState({ applied: true });
    });
  }

  removeCoupon() {
    this.props.removeCoupon().then(() => {
      this.setState({ coupon: '', applied: false });
    });
  }

  render() {
    const { coupon, applied } = this.state;
    const { data, updatingCoupon } = this.props;

    if (!data) {
      return <div></div>;
    }

    return (
      <div className='white_box_details'>
        <h3>Coupons</h3>
        <React.Fragment>
          {applied ? (
            <div className='subscription_coupon'>
              <span>{data.coupon || coupon}</span>
              <Confirm
                onConfirm={this.removeCoupon}
                body={
                  <p>
                    Are you sure you want to remove <br />
                    this coupon?
                  </p>
                }
                confirmText="Remove"
                icon={deleteIcon}
                title="Remove coupon"
              >
                <Button variant='danger' size='md' className='btn-icon'>
                <img src={deleteIcon} alt="delete" />
                </Button>
              </Confirm>
            </div>
          ) : (
            <div className='form_coupon'>
              <label>Enter a coupon</label>
              <input
                className='form-control'
                type="text"
                value={coupon}
                onChange={(e) => {
                  this.setState({ coupon: e.target.value });
                }}
              />
            </div>
          )}
        </React.Fragment>

        {!applied && (
          <Button size='md' onClick={this.applyCoupon}>
            {updatingCoupon ? 'Loading...' : 'Apply coupon'}
          </Button>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    applyCoupon: (coupon) => dispatch(applyCoupon(coupon)),
    removeCoupon: () => dispatch(removeCoupon()),
  };
};

function mapStateToProps(state) {
  return {
    updatingCoupon: state.billing.updatingCoupon,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Coupons);
